export const APP_NAME = 'freelancer_page_perseus';
export const PAGE_NAME = 'business_seller_page';
